import './loading-spinner.scss';

interface LoadingSpinnerProps {
	height?: number;
	width?: number;
	stroke?: number;
	color?: string;
	style?: any;
}

export default function LoadingSpinner(props: LoadingSpinnerProps): JSX.Element {
	const {
		height = 50,
		width = 50,
		stroke = 3,
		color = "#ffffff",
		style = {}
	} = props;

	return (
		<div
			style={{
				height: height,
				width: width,
				transform: "rotate(-90deg)",
				margin: "0 auto",
				...style
			}}
		>
			<svg
				width="100%"
				height="100%"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 100 100"
				preserveAspectRatio="xMidYMid"
				className="lds-rolling"
			>
				<circle
					style={{ animation: "2s loading linear infinite" }}
					cx="50"
					cy="50"
					fill="none"
					stroke={color}
					strokeLinecap="round"
					strokeWidth={stroke}
					r="35"
					strokeDasharray="219.9"
				/>
			</svg>
		</div>
	);
}
